import { render } from "./ProfileView.vue?vue&type=template&id=59f8aca4&ts=true"
import script from "./ProfileView.vue?vue&type=script&lang=ts"
export * from "./ProfileView.vue?vue&type=script&lang=ts"

import "./ProfileView.vue?vue&type=style&index=0&id=59f8aca4&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProfileView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59f8aca4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59f8aca4', __exports__)) {
    api.reload('59f8aca4', __exports__)
  }
  
  module.hot.accept("./ProfileView.vue?vue&type=template&id=59f8aca4&ts=true", () => {
    api.rerender('59f8aca4', render)
  })

}


export default __exports__